import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-rating-heart-5",
  "use": "foquz-icon-rating-heart-5-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-rating-heart-5\"><path d=\"M10.152.848a2.894 2.894 0 00-4.094 0l-.558.558-.558-.558A2.895 2.895 0 00.848 4.942l.558.558L5.5 9.594 9.594 5.5l.558-.558a2.896 2.896 0 000-4.094z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol